module.exports = __webpack_public_path__ + "static/img/googleplay_dark.02630be9.png";